@switch (pageMode) {
  @case ('schools') {
    <ts-toolbar (toggledSidebar)="openSidenav()"></ts-toolbar>
    <ts-sidenav [open]="sidenavOpen" (openedChange)="sidenavOpen = $event">
      <main class="min-h-exceptBothMenus">
        <router-outlet></router-outlet>
      </main>
    </ts-sidenav>
    <ts-footer></ts-footer>
  }
  @case ('tanzspass_com') {
    <ts-tanzspass-com></ts-tanzspass-com>
  }
  @case ('tv') {
    <ts-infosystem-index></ts-infosystem-index>
  }
}
